import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { documentsApi } from './documentsApi';
import { usersApi } from './usersApi';
import { customersApi } from './customersApi';
import { sprawyApi } from './sprawyApi';
import { pelnomocnicyApi } from './pelnomocnicyApi';
import { portalCredentialsApi } from './portalCredentialsApi';
import { courtsApi } from './courtsApi';
import { tenantApi } from './tenantApi';
import { customerUploadLinksApi } from './customerUploadLinksApi';
import { publicUploadApi } from './publicUploadApi';
import { legalProfessionalsApi } from './legalProfessionalsApi';
import { supportApi } from './supportApi';
import { billingApi } from './billingApi';
import { meApi } from './meApi';
import authReducer from './authSlice';
import { rtkQueryErrorMiddleware } from './errorMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [tenantApi.reducerPath]: tenantApi.reducer,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [customersApi.reducerPath]: customersApi.reducer,
    [sprawyApi.reducerPath]: sprawyApi.reducer,
    [pelnomocnicyApi.reducerPath]: pelnomocnicyApi.reducer,
    [portalCredentialsApi.reducerPath]: portalCredentialsApi.reducer,
    [courtsApi.reducerPath]: courtsApi.reducer,
    [customerUploadLinksApi.reducerPath]: customerUploadLinksApi.reducer,
    [publicUploadApi.reducerPath]: publicUploadApi.reducer,
    [legalProfessionalsApi.reducerPath]: legalProfessionalsApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [meApi.reducerPath]: meApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      tenantApi.middleware,
      documentsApi.middleware,
      usersApi.middleware,
      customersApi.middleware,
      sprawyApi.middleware,
      pelnomocnicyApi.middleware,
      portalCredentialsApi.middleware,
      courtsApi.middleware,
      customerUploadLinksApi.middleware,
      publicUploadApi.middleware,
      legalProfessionalsApi.middleware,
      supportApi.middleware,
      billingApi.middleware,
      meApi.middleware,
      rtkQueryErrorMiddleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
